import React, { Component } from 'react';
import PropTypes from 'prop-types';
import format from 'date-fns/format';

class StatusLabel extends Component {
  render () {
    return(
      <strong> {
        (this.props.isDiscontinued || this.props.isComingSoon || this.props.callForPricing)
          ? <span className="color-alert">{this.props.isDiscontinued ? 'Discontinued' : (this.props.callForPricing ? 'Call for pricing' : 'Coming Soon')}</span>
          : (
            this.props.remainingStock
              ? (
                this.props.specialShipDays && this.props.specialShipDays >= this.props.backorderShipDays
                  ? <span className="color-warning">Special order<span className="-ship-date">: Expected to Ship {format(this.props.specialShipDate * 1000, 'dddd, MMM Do')}</span></span>
                  : (
                    this.props.backorderShipDays
                      ? <span className="color-warning">Backorder<span className="-ship-date">: Expected to Ship {format(this.props.backorderShipDate * 1000, 'dddd, MMM Do')}</span></span>
                      : <span className="color-success">In Stock</span>
                  )
              )
              : <span className="color-alert">Out of stock</span>
          )
        }
      </strong>
    );
  }
}

StatusLabel.propTypes = {
  remainingStock: PropTypes.number.isRequired,
  specialShipDate: PropTypes.number.isRequired,
  backorderShipDate: PropTypes.number.isRequired,
  isDiscontinued: PropTypes.bool.isRequired,
  isComingSoon: PropTypes.bool.isRequired,
  callForPricing: PropTypes.bool.isRequired,
};

export default StatusLabel;
